import { UserPlusIcon } from '@heroicons/react/20/solid';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { findLink } from '../../../../../LinkyLinky';
import ParticipantsStore from '../../../../../ParticipantsStore';
import { Link } from '../../../../../Resource/Types';
import { T } from '../../../../../Translations';

interface Props {
  participantsStore: ParticipantsStore;
  loading: (link: Link, participantsStore: ParticipantsStore) => void;
}

function OpenModalButton({ participantsStore, loading }: Props) {
  return findLink('bulk-assign-revoke-license', participantsStore.links)
    .map((link) => (
      <button
        className="flex rounded-md border-[1px] items-center border-solid border-teal-600 px-5 py-2 text-teal-600"
        onClick={() => loading(link, participantsStore)}
        data-intercom-target="bulk-license-manage-licenses-button"
      >
        <span className="mr-2">
          <UserPlusIcon height="30px" />
        </span>
        <T kind="Manage Licenses" />
      </button>
    ))
    .getOrElse(emptyFragment);
}

export default observer(OpenModalButton);
